import React from 'react';

import styles from './search-results-action-wrapper.module.scss';

interface SearchResultsActionWrapperProps {
  label: string;
  children: React.ReactNode;
}

export const SearchResultsActionWrapper: React.FC<
  SearchResultsActionWrapperProps
> = ({ label, children }) => {
  return (
    <div className={styles.resultsAction}>
      <span className={styles.resultsActionLabel}>{label}</span>
      {children}
    </div>
  );
};
